import React, { useContext, useMemo } from 'react';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import { EditModifierContext, IEditModifierContext } from '../../editModifierState/editModifierContext';
import style from './ControlPanel.module.scss';

const ControlPanel: React.FC = () => {
	const { changeVisibleForm, visibleForm, defaultCustomerLanguage, translations } =
		useContext<IEditModifierContext>(EditModifierContext);

	const hasTranslationError = useMemo(() => {
		if (!defaultCustomerLanguage) {
			return false;
		}
		const defaultNameTranslation = translations.find(
			(translation) => translation.languageId === defaultCustomerLanguage.id,
		)?.name;
		return !defaultNameTranslation;
	}, [defaultCustomerLanguage, translations]);

	return (
		<div className={style.container} data-test="ControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('translations')}
				isActive={visibleForm === 'translations'}
				btnName="translationsBookmark"
				isError={hasTranslationError}
			/>
		</div>
	);
};

export default ControlPanel;
